import { ArrowRight, Copy } from 'lucide-react';
import { toast } from 'sonner';

import type { CampaignAnalysisCreatorDiscoveryGuide } from '@/entities/campaign/generated/campaign-type';
import { Button } from '@/shared/components/shadcn/button';

export function CreatorGuideSection({
  creator_discovery_guides,
  onOpenDiscovery,
}: {
  creator_discovery_guides: readonly CampaignAnalysisCreatorDiscoveryGuide[];
  onOpenDiscovery: (prompt: string) => void;
}) {
  const visible_creator_discovery_guides = creator_discovery_guides.slice(0, 3);

  return (
    <div className="grid gap-4">
      {visible_creator_discovery_guides.map((guide, index) => (
        <CreatorGuidePromptCard
          key={guide.title}
          guide={guide}
          index={index}
          onOpenDiscovery={onOpenDiscovery}
        />
      ))}
    </div>
  );
}

function CreatorGuidePromptCard({
  onOpenDiscovery,
  guide,
  index,
}: {
  onOpenDiscovery: (prompt: string) => void;
  guide: CampaignAnalysisCreatorDiscoveryGuide;
  index: number;
}) {
  const handleCopyPrompt = async () => {
    await navigator.clipboard.writeText(guide.prompt);
    toast.success(`${guide.title} prompt copied.`);
  };

  return (
    <div
      data-campaign-analysis-print-avoid-break
      className="border-border bg-card flex min-w-0 flex-col rounded-xl border p-5 shadow-sm sm:p-6 print:p-4"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-muted-foreground text-sm leading-5 font-semibold tabular-nums">
            Prompt {index + 1}
          </p>
          <h4 className="text-foreground mt-1 text-lg leading-6 font-bold break-words">
            {guide.title}
          </h4>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 shrink-0 px-2.5 font-semibold"
          onClick={() => onOpenDiscovery(guide.prompt)}
        >
          <ArrowRight className="size-4" />
          Discovery
        </Button>
      </div>
      <div className="bg-muted mt-5 rounded-lg p-4 print:mt-3 print:p-3">
        <p className="text-muted-foreground text-sm leading-6">{guide.prompt}</p>
        <Button
          variant="ghost"
          size="sm"
          className="text-muted-foreground hover:text-foreground mt-3 h-7 px-1.5 text-xs font-medium"
          onClick={handleCopyPrompt}
        >
          <Copy className="size-3.5" />
          Copy
        </Button>
      </div>
    </div>
  );
}
